<template>
  <div class="placeholder">
    <Heading level="h2">iLOQ Digital Business Platform</Heading>
    <Paragraph>Placeholder for '{{ page }}'</Paragraph>
    <p>
      User is in the following groups: <b>{{ user.groups.join(", ") }}</b>
    </p>
    <p><a href="/logout">Logout from iLOQ Partner Portal</a></p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";

import Heading from "@/design-system/elements/Heading.vue";
import Paragraph from "@/design-system/elements/Paragraph.vue";
import { IRootState } from "@iloq/shared";

export default defineComponent({
  components: {
    Heading,
    Paragraph,
  },
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      user: (state: unknown) => (state as IRootState).user!,
    }),
  },
  methods: {
    loadUser() {
      this.$store.dispatch("fetchUser");
    },
  },
});
</script>
